import { render, staticRenderFns } from "./classification-rule-detail.vue?vue&type=template&id=1d6e82d8&scoped=true"
import script from "./classification-rule-detail.vue?vue&type=script&lang=js"
export * from "./classification-rule-detail.vue?vue&type=script&lang=js"
import style0 from "./classification-rule-detail.vue?vue&type=style&index=0&id=1d6e82d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6e82d8",
  null
  
)

export default component.exports